import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-281">
      <div className="max-w-3xl mx-auto text-center" data-id="element-282">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-10" data-id="element-283">
          Si sos docente de Português en Argentina,
          <br data-id="element-284" />
          <span className="text-[#39FF14]" data-id="element-285">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-4 text-left mb-12" data-id="element-286">
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-287">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-288">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-289">
              Domingo a la noche buscando actividades en internet que nunca
              quedan bien, están en portugués de Portugal o no se adaptan al
              alumno argentino
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-290">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-291">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-292">
              Llegás al lunes con algo que "más o menos sirve" y durante la
              clase te das cuenta que le falta estructura, cierre, solucionario
              y evaluación
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-293">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-294">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-295">
              Tenés que armar planificaciones para jefatura o inspección a las
              corridas, la noche anterior, sin saber si están bien formuladas
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-296">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-297">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-298">
              Tus evaluaciones son siempre las mismas o siempre inventadas
              porque no tenés un banco de instrumentos serios con solucionario
              incluido
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-299">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-300">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-301">
              Cuando el tema es difícil —verbos irregulares, subjuntivo, falsos
              amigos— no sabés cómo explicarlo sin perder al curso en el camino
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-302">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-303">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-304">
              Tenés alumnos con NEE o diferentes niveles y no tenés material
              adaptado — así que improvisás o los dejás de lado sin querer
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-305">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-306">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-307">
              El material que encontrás online está en portugués de Portugal, no
              conecta con Brasil ni con la realidad argentina, y encima está
              incompleto
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-308">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-309">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-310">
              Trabajás de lunes a viernes, llegás al fin de semana agotado/a y
              el domingo volvés a empezar el ciclo de buscar, armar e improvisar
            </p>
          </div>
        </div>

        <p className="text-[#39FF14] text-2xl sm:text-3xl font-black mb-8" data-id="element-311">
          ¿Cuántos domingos más vas a perder haciendo lo mismo?
        </p>

        {/* Green divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#39FF14] to-transparent w-full" data-id="element-312" />
      </div>
    </section>;
}